/**
 * Constants for File Matcher Module
 */

"use strict";

export const SEARCH_LIMIT = 300;

// Check if debug mode is enabled (global)
const urlParams = new URLSearchParams(window.location.search);
export const debugMode = urlParams.get('debug') || '0';

